import { api } from "@/api";
import { AxiosResponse } from "axios";
import { PayloadRoundTableList } from "../types";

class API {
  static postNewRoundTable(payload: any): Promise<AxiosResponse> {
    return api.post("/debate", payload);
  }
  static postNewPostRoundTable(payload: any): Promise<AxiosResponse> {
    return api.post("/debate/post", payload);
  }
  static putEditPostRoundTable(payload: any): Promise<AxiosResponse> {
    return api.put("/debate/post", payload);
  }
  static getRoundTable(payload: any): Promise<AxiosResponse> {
    return api.get(`/debate/${payload.id}/feed`, { params: payload.params });
  }
  static postCommentRoundTable(payload: any): Promise<AxiosResponse> {
    return api.post(`/interaction/comment/${payload.postId}`, payload.params);
  }
  static putCommentRoundTable(payload: any): Promise<AxiosResponse> {
    return api.put(`/interaction/comment/${payload.commentId}`, payload.params);
  }
  static deleteCommentRoundTable(payload: any): Promise<AxiosResponse> {
    return api.delete(`/interaction/comment/${payload.commentId}`);
  }
  static getRoundTableList(
    payload: PayloadRoundTableList
  ): Promise<AxiosResponse> {
    return api.get("/debate/list", { params: payload });
  }
  static getRoundTableDetail(payload: string): Promise<AxiosResponse> {
    return api.get(`/debate/${payload}/detail`);
  }
}
export default API;
